// Model imports
const {
  ARTICLE_IS_MIXED_CHANGE_PENDING,
  ARTICLE_UPDATED
} = require('./actions')
const ArticleModelRecord = require('./record')

// eslint-disable-next-line complexity
function articleReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof ArticleModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this article
  if (state['url_id'] !== payload.urlId) {
    return state
  }
  switch (type) {
    case ARTICLE_IS_MIXED_CHANGE_PENDING:
      return state.merge({
        isMixed: ARTICLE_IS_MIXED_CHANGE_PENDING
      })
    case ARTICLE_UPDATED:
      return state.mergeDeep(payload.article)
    default:
      return state
  }
}

module.exports = articleReducer
